import type { FC } from 'react'

import { PayoutScheme } from '@pages/IntroducingBroker/Dashboard/PayoutScheme/PayoutScheme'
import { useMultiLevelCommission } from '@pages/IntroducingBroker/Dashboard/hooks/useMultiLevelCommission'
import { usePayoutScheme } from '@pages/IntroducingBroker/Dashboard/hooks/usePayoutScheme'
import { useIntroducingBrokerById } from '@pages/IntroducingBroker/hooks/useIntroducingBrokerById'
import { useIntroducingBrokerLegalDocuments } from '@pages/IntroducingBroker/hooks/useIntroducingBrokerLegalDocuments'

import { useIBReferralCodes } from '@hooks/useIBReferralCodes'

export const PayoutSchemeWidget: FC = () => {
  const { data: ibData, isLoading: isIbDataLoading } = useIntroducingBrokerById()

  const { legalDocumentsSchemes } = useIBReferralCodes()

  const { data: legalDocuments, isLoading: isLegalDocumentsLoading } =
    useIntroducingBrokerLegalDocuments({
      legalDocumentsSchemes,
    })

  const {
    data: multiLevelData,
    isLoading: isMultiLevelDataLoading,
    dismissNotification,
  } = useMultiLevelCommission({
    isPaused: !ibData?.hasMultiLevelCommission,
  })

  const isMultiLevelLoading = isLegalDocumentsLoading || isIbDataLoading || isMultiLevelDataLoading

  const {
    data: payoutSchemeData,
    isLoading: isPayoutSchemeLoading,
    schemeMetaDataByTabId,
  } = usePayoutScheme()

  return (
    <PayoutScheme
      isLoading={isMultiLevelLoading || isPayoutSchemeLoading}
      legalDocuments={legalDocuments ?? []}
      multiLevelData={multiLevelData ?? undefined}
      payoutSchemeData={payoutSchemeData}
      schemeMetaDataByTabId={schemeMetaDataByTabId}
      dismissNotification={dismissNotification}
    />
  )
}
